import React from 'react';
import Component from './Component';
import {TextInput as BaseInput} from 'reactis-forms';
import classNames from 'classnames'
import Glyphicon from './Glyphicon';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

class Text extends React.Component {

	static filterDelay  = true;
	static contextTypes = {
		form: React.PropTypes.object
	};

	getError() {
		return this.props.error && this.props.error[0];
	}

	focus() {
		this.refs.input.focus();
	}

	render() {
		const val = this.props.renderer(this.props.value, this.context.form.getValues().toJS());
		return <div>{val}</div>;
	}
}

Text.propTypes = {
	type: React.PropTypes.string,
	label: React.PropTypes.node,
	help: React.PropTypes.node,
	addonBefore: React.PropTypes.node,
	addonAfter: React.PropTypes.node,
	buttonBefore: React.PropTypes.node,
	buttonAfter: React.PropTypes.node,
	bsSize: React.PropTypes.oneOf(['small', 'medium', 'large']),
	bsStyle: React.PropTypes.oneOf(['success', 'warning', 'error']),
	hasFeedback: React.PropTypes.bool,
	feedbackIcon: React.PropTypes.node,
	id: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.number
	]),
	groupClassName: React.PropTypes.string,
	wrapperClassName: React.PropTypes.string,
	labelClassName: React.PropTypes.string,
	disabled: React.PropTypes.bool,
	value: React.PropTypes.any
};

Text.defaultProps = {
	type: 'text',
	disabled: false,
	hasFeedback: false
};

export default Text;


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/Text.js